// extracted by mini-css-extract-plugin
module.exports = {"menuLinks":"_7240e6c","link":"_748d2e8"};